import { connect } from 'react-redux'

import BotEditor from 'components/BotEditor'

const mapStateToProps = (state) => ({
  classifications: state.__PLAYBOOK_EDITOR.classifications,
})

export default connect(mapStateToProps)(BotEditor)
